<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.admin_list")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.account_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="account_id"
                    :placeholder='$t("ui.account_id")'
                    v-model="account_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              //- .col-sm-12.col-md-6.col-lg-6.col-xl-2
              //-   b-input-group(:prepend="$t('ui.status')" size="sm")
              //-     b-form-select(
              //-       ref="status"
              //-       v-model="status"
              //-       :options="$helpers.getStatusList()"
              //-       size="sm"
              //-       @change="submit"
              //-     )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            b-row
              //- .col-sm-12.col-md-12.col-lg-12.col-xl-12
              //-   .alert.alert-warning.mb-1 {{ $t("message.jackpot_alert") }}
            template(v-if="$helpers.getVisible(editAccount) && !$helpers.isAgentLevel()")
              b-row(:class="{ 'd-none' : $store.getters.accountStatus == 'SUSPEND' }")
                .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                  //- b-button(type="button" variant="warning" size="sm" to="/newAccount")
                  b-button(type="button" variant="warning" size="sm" v-b-modal.addAdmin :disabled="$helpers.isSuspended()")
                    i.fa.fa-plus.mr-1
                    //- span {{ $t("ui.new") + ' ' + $helpers.getUplineName($store.getters.accountType) }}
                    span {{ $t("ui.new_admin") }}
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.tblAgent.table-sm.table-hover.table-bordered(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="adminList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged" :tbody-tr-class="rowClass")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(account_id)="row")
                    .d-flex
                      //- b-link.mr-1(v-show="!$helpers.isAgentLevel()" @click="redirectTo(row.item, 'viewDownline')" style="text-decoration:none;") #[b {{ row.item.account_id.toUpperCase() }}]
                      span.mr-1 #[b {{ row.item.account_id.toUpperCase() }}]
                      //- .ml-auto(v-if="$helpers.getVisible(editAccount)")
                      //-   a.fas.fa-lg.fa-fw.fa-copy.text-dark.mt-1(
                      //-     @click="redirectTo(row.item, 'newAccount?id=searchCopy')"
                      //-     :title="$t('ui.copy')"
                      //-     style="cursor: pointer;float:right;"
                      //-   )
                  template(v-slot:cell(login_id)="row")
                    span(v-if="row.item.login_id") {{ row.item.login_id.toUpperCase() }}
                  template(v-slot:cell(status)="row")
                    div.d-flex.flex-nowrap(style="justify-content: center;")
                      template(v-if="row.item.profile_status == 'BLOCK'")
                        SubmitButton(:loading="loading" size="sm" icon="fa fa-times" :text="$t('ui.block')" isModal=false type="button" variant="danger" @click="unblockProfile(row.item)" :disabled="$helpers.isSuspended()")
                      template(v-else)
                        template(v-if="$helpers.isSuspended()")
                          b-form-select(
                            size="sm"
                            v-model="row.item.status"
                            disabled
                          )
                            option(value="ACTIVE") {{ $t("ui.active") }}
                            option(value="CLOSE") {{ $t("ui.close") }}
                            option(value="SUSPEND") {{ $t("ui.suspend") }}
                        template(v-else)
                          b-form-select(
                            size="sm"
                            v-model="row.item.status"
                            @change="updateStatus(row.item, $event)"
                            :disabled="!$helpers.getVisible(editAccount)"
                            :style="{ background: row.item.status == 'SUSPEND' ? '#fce3bf' : row.item.status == 'CLOSE' ? '#ffd1d0' : '' }"
                          )
                            template(v-if="row.item.status == 'FREEZE'")
                              option(
                                value="FREEZE"
                                :disabled="row.item.status == 'FREEZE'"
                              ) {{ $t("ui.freeze") }}
                            template(v-else)
                              option(
                                value="ACTIVE"
                                :disabled="row.item.status == 'ACTIVE'"
                              ) {{ $t("ui.active") }}
                              option(
                                value="CLOSE"
                                :disabled="row.item.status == 'CLOSE'"
                              ) {{ $t("ui.close") }}
                              option(
                                v-if="!$helpers.isAgentLevel()"
                                value="SUSPEND"
                                :disabled="row.item.status == 'CLOSE' || row.item.status == 'SUSPEND'"
                              ) {{ $t("ui.suspend") }}
                  template(v-slot:cell(created_date)="row")
                    span {{ $moment(row.item.created_date).format("YYYY-MM-DD HH:mm:ss") }}
                  template(v-slot:cell(action)="row")
                    div.d-flex.flex-nowrap(style="justify-content: center;")
                      b-button-group
                        template(v-if="$helpers.getVisible(editAccount)")
                          span
                            template(v-if="$helpers.isSuspended()")
                              a.fas.fa-lg.fa-fw.fa-lock.text-warning(
                                style="cursor: pointer;"
                              )
                            template(v-else)
                              a.fas.fa-lg.fa-fw.fa-lock.text-warning(
                                v-b-modal.resetPassword
                                @click="setEditSelectedModal(row.item)"
                                :title="$t('ui.password')"
                                style="cursor: pointer;"
                              )

      addAdmin(@clicked="submit")
      resetPasswordAdmin(:accountId="updateAccountID")

</template>

<script>
import config from "@/config"
import addAdmin from "@/components/modal/addAdmin.vue"
import SubmitButton from "@/library/SubmitButton"
import resetPasswordAdmin from "@/components/modal/resetPasswordAdmin.vue"
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    resetPasswordAdmin,
    DebounceInput,
    addAdmin
  },
  data() {
    return {
      account_id: "",
      adminList: [],
      updateAccountID: "",
      updateAccountType: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      filter: null,
      sortBy: "account_id",
      sortDesc: false,
      currentPage: 1,
      totalRows: 0,
      status: ""
    }
  },
  validations: {},
  computed: {
    editAccount() {
      return [config.accessRoles.editAccount]
    },
    // editStatus() {
    //   return [config.accessRoles.editStatus]
    // },
    report() {
      return [config.accessRoles.report]
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "login_id",
          label: this.$t("ui.login_id"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "full_name",
          label: this.$t("ui.full_name"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "contact_phone",
          label: this.$t("ui.contact_phone"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "8%"
          }
        },
        {
          key: "action",
          label: this.$t("ui.action"),
          class: "align-middle text-center",
          thClass: "bg-grey"
        },
        {
          key: "status",
          label: this.$t("ui.status"),
          class: "align-middle text-center m-110",
          thClass: "bg-grey",
          thStyle: {
            width: "8%"
          }
        },
        {
          key: "last_login_ip",
          label: this.$t("ui.login_ip"),
          class: "align-middle text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "6%"
          }
        },
        {
          key: "created_date",
          label: this.$t("ui.created_on"),
          class: "align-middle text-right",
          thClass: "bg-grey",
          thStyle: {
            width: "8%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function(){
    this.$helpers.getPlatform()
    this.submit()
  },
  methods: {
    // searchFrom: function() {
    //   if(this.search_id != this.$store.getters.accountID) {
    //     this.$store.dispatch("user/setSelectedID", this.search_id)
    //     this.$router.push("/search").catch(err=>{})
    //   }
    // },
    rowClass(item, type) {
      if (!item) return
      if (item.status === 'SUSPEND') return 'table-warning'
      if (item.status === 'CLOSE') return 'table-danger'
    },
    // getRemainingCredit: function(account) {
    //   let account_id = account.account_id
    //   let account_type = account.account_type
    // },
    redirectTo: function(account, page) {
      this.$store.dispatch("user/setSelectedID", account.account_id)
      this.$store.dispatch("user/setSelectedType", account.account_type)
      this.$router.push("/" + page)
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable()
    },
    refreshTable() {
      this.$root.$emit("bv::table::refresh", "tblList")
    },
    setEditSelectedModal: function(account) {
      this.updateAccountID = account.account_id
      this.updateAccountType = account.account_type
    },
    unblockProfile: function(account) {
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.unblock_account_profile_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          let account_id = account.account_id
          let client_ip = this.$helpers.getClientIP()
          this.loading = true
          this.$store
            .dispatch("user/unblockProfile", { account_id, client_ip })
            .then(response => {
              this.loading = false
              this.submission.success = response.success
              // this.submission.status = response.errorTag
              if (this.submission.success == true) {
                this.$swal({
                  title: this.$t("ui.succeed"),
                  text: this.$t("message.unblock_account_profile_success"),
                  type: "success",
                  allowOutsideClick: false
                }).then(isConfirm => {
                  if (isConfirm) {
                    this.submit();
                  }
                });
              }
            })
            .catch(response => {
              this.loading = false
              if((typeof response.errorTag) != 'object') {
                this.submission.success = response.success
                this.submission.status = this.$t("message." + response.errorTag)
              }
            });
        } else if (
          // Read more about handling dismissals
          result.dismiss === 'cancel'
        ) {
          this.loading = false
          this.$swal({
            title: this.$t("ui.cancel"),
            text: this.$t("message.unblock_account_profile_cancel"),
            type: "error",
            allowOutsideClick: false
          }).then(isConfirm => {
            if (isConfirm) {
              this.submit()
            }
          });
        }
      });
    },
    updateStatus: function(account, status) {
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.update_account_status_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          let account_id = account.account_id
          let client_ip = this.$helpers.getClientIP()
          this.loading = true
          this.$store
            .dispatch("user/updateStatusAdmin", { account_id, status, client_ip })
            .then(response => {
              this.loading = false
              this.submission.success = response.success
              // this.submission.status = response.errorTag
              if (this.submission.success == true) {
                this.$swal({
                  title: this.$t("ui.succeed"),
                  text: this.$t("message.update_account_status_success"),
                  type: "success",
                  allowOutsideClick: false
                }).then(isConfirm => {
                  if (isConfirm) {
                    this.submit();
                  }
                });
              }
            })
            .catch(response => {
              this.loading = false
              if((typeof response.errorTag) != 'object') {
                this.submission.success = response.success
                this.submission.status = this.$t("message." + response.errorTag)
              }
            });
        } else if (
          // Read more about handling dismissals
          result.dismiss === 'cancel'
        ) {
          this.loading = false
          this.$swal({
            title: this.$t("ui.cancel"),
            text: this.$t("message.update_account_status_cancel"),
            type: "error",
            allowOutsideClick: false
          }).then(isConfirm => {
            if (isConfirm) {
              this.submit()
            }
          });
        }
      });
    },
    submit: function() {
      this.getAdminList()
    },
    getAdminList: function() {
      if (!this.$v.$invalid) {
        let search_id = this.account_id
        let page_number = this.currentPage;
        this.currentPage = parseInt(page_number);
        let page_size = this.perPage;
        let sort_key = this.sortBy;
        let sort_type = this.direction;
        let client_ip = this.$helpers.getClientIP()
        this.loading = true
        this.$store
          // .dispatch("user/getAccountList", { search_id, target_account_id, start_date, end_date, page_number, page_size, sort_key, sort_type })
          .dispatch("user/getAdminList", { search_id, page_number, page_size, sort_key, sort_type, client_ip })
          .then(response => {
            this.loading = false
            this.submission.success = response.success;

            // this.submission.status = response.errorTag;
            if (this.submission.success == true) {
              this.adminList = response.data
              this.totalRows = response.data.length > 0 ? this.adminList[0]["totalrows"] : 0;
            }
          })
          .catch(response => {
            this.loading = false
            if((typeof response.errorTag) != 'object') {
              this.submission.success = response.success
              this.submission.status = this.$t("message." + response.errorTag);
            }
          });
      }
    },
    // getMemberList: function() {
    //   if (!this.$v.$invalid) {
    //     let search_id = this.account_id
    //     let target_account_id = this.$store.getters.accountID
    //     let start_date = "";//(this.dateRange[0] != null) ? ((this.dateRange[0] != "") ? this.$(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
    //     let end_date = "";//(this.dateRange[1] != null) ? ((this.dateRange[1] != "") ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
    //     let page_number = this.currentPage;
    //     this.currentPage = parseInt(page_number);
    //     let page_size = this.perPage;
    //     // let sort_key = this.sortBy;
    //     // let sort_type = this.direction;
    //     let account_status = this.status;
    //     this.loading = true
    //     this.$store
    //       // .dispatch("user/getMemberList", { search_id, target_account_id, start_date, end_date, page_number, page_size, sort_key, sort_type })
    //       .dispatch("user/getMemberList", { search_id, target_account_id, start_date, end_date, page_number, page_size, account_status })
    //       .then(response => {
    //         this.loading = false
    //         this.submission.success = response.success;
    //         // this.submission.status = response.errorTag;
    //         if (this.submission.success == true) {
    //           this.adminList = response.data
    //           this.totalRows = response.data.length > 0 ? this.adminList[0]["totalrows"] : 0;
    //         }
    //       })
    //       .catch(response => {
    //         this.loading = false
    //         this.submission.success = response.success
    //         this.submission.status = this.$t("message." + response.errorTag);
    //       });
    //   }
    // }
  }
}
</script>